import EditIcon from '@/app/icons/edit'
import { EditContext } from '@/context/edit-manager'
import UserContext from '@/context/user-context'
import { cn } from '@/util/cn'
import { useContext } from 'react'
export const StaffModeToggle = ({ className }: { className?: string }) => {
    const { user } = useContext(UserContext)
    const { staffMode, setStaffMode } = useContext(EditContext)
    return user?.is_staff ? (
        <div
            className={cn('group flex cursor-pointer items-center gap-2', className)}
            onClick={() => setStaffMode((mode) => !mode)}
        >
            <EditIcon
                className={cn(
                    'size-3',
                    staffMode
                        ? 'fill-giphyGreen group-hover:opacity-80'
                        : 'fill-giphyLightCharcoal group-hover:fill-giphyLightestGrey'
                )}
            />{' '}
            <div
                className={cn(
                    'font-bold',
                    staffMode
                        ? 'text-giphyGreen group-hover:opacity-80'
                        : 'text-giphyLightCharcoal group-hover:text-giphyLightestGrey'
                )}
            >
                Staff Mode
            </div>
        </div>
    ) : null
}
